import { ARCHIVED_COLUMN, LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Region',
    field: 'regionName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Company',
    field: 'name',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Services',
    field: 'services',
    width: LIST_WIDTH.xl,
    cellRenderer: 'iconComponent',
  },
  {
    headerName: 'Account Holder',
    field: 'accountHolder',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  { headerName: 'Email', field: 'email', width: LIST_WIDTH.xl },
  {
    headerName: 'Phone',
    field: 'phone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  {
    headerName: 'Num Sites',
    field: 'numSites',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Num Managers',
    field: 'numManagers',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Num Supervisors',
    field: 'numSupervisors',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Num Responders',
    field: 'numResponders',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Num Guards',
    field: 'numGuards',
    width: LIST_WIDTH.default,
  },
  // {
  //   headerName: 'Num Drivers',
  //   field: 'numDrivers',
  //   width: LIST_WIDTH.default,
  // },
  {
    headerName: 'Num Cleaners',
    field: 'numCleaners',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Num Maintainers',
    field: 'numMaintainers',
    width: LIST_WIDTH.default,
  },
];
